import { StringKeys } from '@/shared/utils/string-keys'

export function sortBy<T>(
  transform: StringKeys<T> | ((a: T) => any),
  order: 'asc' | 'desc' = 'asc'
): (a: T, b: T) => any {
  const reverse: boolean = order === 'desc'

  return (a, b) => {
    let result: number

    let valueA: any
    let valueB: any

    if (typeof transform === 'string') {
      valueA = a[transform]
      valueB = b[transform]
    } else {
      valueA = transform(a)
      valueB = transform(b)
    }

    if (reverse) {
      result = valueB > valueA ? 1 : -1
    } else {
      result = valueA > valueB ? 1 : -1
    }

    return result
  }
}
